import { ViewModel,View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import  { ImportView } from "./import-view"

export class ImportViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    closePopup(result?: any) {
    }
    GetDefaultView(): View <ViewModel> {
        return new ImportView();
    }
    public getTypeId(): string {
        return "VM-B76D8B19-471B-4B5E-8FA6-F51451602F3F"
    }

    public set text(v: string) { this._text = v; } public get text(): string { return this._text;} private _text: string;

    confirm(){
        this.closePopup(this.text);
    }
    close(){
        this.closePopup();
    }
}
